import globalMU from "globalMU"
import React from "react"
const estiloUltimasComprasProduto = require("./ultimasComprasProdutos.module.scss").default;
const estiloTabela = require('../../estilos/tabelas.module.scss').default

export type UltimasComprasProdutosProps = {
    dadosUltimasCompras: DadosUltimasCompras[]
}

export type FiltroUltimasComprasProdutos = {
    CodigoCliente: number
    CodigoFilial: string
    CodigosProdutos: string[]
}

export type DadosUltimasCompras = {
    CodigoFilial: string,
    Codigo?: any,
    Referencia?: any,
    CodigoProduto: string,
    Numero: string,
    Serie: string,
    DataEmissao: string,
    UnidadeMedida: string,
    Quantidade: number,
    Preco: number,
    PrecoFormatado: string,
    QuantidadeEstoque: number,
    UserMessage?: string,
    Transforming: boolean
}

export const UltimasComprasProdutos = (props: UltimasComprasProdutosProps) => {
    const table = () => {
        const tableHead = <div className="_table-header-group ">
            <div className="_table-row">
                <div className={`_table-cell _font-bold _align-middle _px-2 _shadow-[1px_1px_rgb(255_255_255/50%)_inset] _bg-[#daddde] _border _border-[#c5cacb]`}>
                    Código
                </div>
                <div className={`_table-cell _font-bold _align-middle _px-2 _shadow-[1px_1px_rgb(255_255_255/50%)_inset] _bg-[#daddde] _border _border-[#c5cacb]`}>
                    Filial
                </div>
                <div className={`_table-cell _font-bold _align-middle _px-2 _shadow-[1px_1px_rgb(255_255_255/50%)_inset] _bg-[#daddde] _border _border-[#c5cacb]`}>
                    NF
                </div>
                <div className={`_table-cell _font-bold _align-middle _px-2 _shadow-[1px_1px_rgb(255_255_255/50%)_inset] _bg-[#daddde] _border _border-[#c5cacb] _text-right`}>
                    Data Emissão
                </div>
                <div className={`_table-cell _font-bold _align-middle _px-2 _shadow-[1px_1px_rgb(255_255_255/50%)_inset] _bg-[#daddde] _border _border-[#c5cacb] _text-right`}>
                    Unidade
                </div>
                <div className={`_table-cell _font-bold _align-middle _px-2 _shadow-[1px_1px_rgb(255_255_255/50%)_inset] _bg-[#daddde] _border _border-[#c5cacb] _text-right`}>
                    Quantidade
                </div>
                <div className={`_table-cell _font-bold _align-middle _px-2 _shadow-[1px_1px_rgb(255_255_255/50%)_inset] _bg-[#daddde] _border _border-[#c5cacb] _text-right`}>
                    Valor Unitário
                </div>
                <div className={`_table-cell _font-bold _align-middle _px-2 _shadow-[1px_1px_rgb(255_255_255/50%)_inset] _bg-[#daddde] _border _border-[#c5cacb] _text-right`}>
                    Estoque Disponível
                </div>
            </div>
        </div>

        const tableBody = <div className="_table-row-group">
            {props.dadosUltimasCompras?.map((ultimasCompras) => (
                <div className={`_table-row _cursor-pointer hover:_bg-white`} key={ultimasCompras.Codigo}>
                    <div className={`_table-cell _border _border-[#c5cacb] _px-2 _align-middle`}>{ultimasCompras.CodigoProduto}</div>
                    <div className={`_table-cell _border _border-[#c5cacb] _px-2 _align-middle`}>{ultimasCompras.CodigoFilial}</div>
                    <div className={`_table-cell _border _border-[#c5cacb] _px-2 _align-middle`}>{`${ultimasCompras.Numero}-${ultimasCompras.Serie}`}</div>
                    <div className={`_table-cell _border _border-[#c5cacb] _px-2 _align-middle _text-right`}>{globalMU.formatDate(ultimasCompras.DataEmissao)}</div>
                    <div className={`_table-cell _border _border-[#c5cacb] _px-2 _align-middle _text-right`}>{ultimasCompras.UnidadeMedida}</div>
                    <div className={`_table-cell _border _border-[#c5cacb] _px-2 _align-middle _text-right`}>{ultimasCompras.Quantidade}</div>
                    <div className={`_table-cell _border _border-[#c5cacb] _px-2 _align-middle _text-right`}>{globalMU.formatarValorNumerico(ultimasCompras.Preco, 3, false)}</div>
                    <div className={`_table-cell _border _border-[#c5cacb] _px-2 _align-middle _text-right`}>{globalMU.formatarValorNumerico(ultimasCompras.QuantidadeEstoque, 3, false)}</div>
                </div>
            ))}
        </div>

        return <div className={`_table _w-full _border-collapse`}>
            {tableHead}
            {tableBody}
        </div>
    }
    return (
        <>
            <div className={estiloTabela.containerRolavel}>
            {table()}
            </div>
            {<section style={{ marginBottom: "100px" }} />}
        </>
    )
}